
import { Component, Ref, Prop, Vue } from 'vue-property-decorator'
import InputTextBase from '@/components/atoms/InputTextBase.vue'
import ModalWindow from '@/components/molecules/ModalWindow.vue'
import ButtonSubmitSquare from '@/components/molecules/ButtonSubmitSquare.vue'
import SingleChoices from '@/components/organisms/study/SingleChoices.vue'

/**
 * 択一式入力モーダル
 */
@Component({
  components: {
    InputTextBase,
    ModalWindow,
    ButtonSubmitSquare,
    SingleChoices,
  },
})
export default class ModalInputSingleChoice extends Vue {
  /** モーダルウィンドウ */
  @Ref()
  modalWindow!: ModalWindow

  /** 選択部分 */
  @Ref()
  singleChoices!: SingleChoices

  /**
   * モーダルをドラッグ可能にするか否か
   *   デフォルトはOFF=位置固定
   */
  @Prop({ default: false })
  draggable!: boolean

  /** タイトル文字列 */
  private title = ''

  /** 入力値 */
  private inputValue = ''

  /** 選択肢 */
  private optionValues: string[] = []

  /**
   * モーダルのドラッグ対象
   *
   * @returns ドラッグ不可の場合false、可の場合CSSセレクタ
   */
  private get draggableTarget(): boolean | string {
    // ドラッグ不可の場合はfalseを固定で返す
    if (!this.draggable) {
      return false
    }

    // ドラッグ可の場合はヘッダ部のCSSセレクタを返す
    return '.modal-input-single-choice__main__header'
  }

  /**
   * モーダルの消去処理
   */
  public hide(): void {
    this.modalWindow.hide()
  }

  /**
   * モーダルの表示処理
   *
   * @param title タイトル文字列
   * @param optionValues 選択肢の文字列リスト
   * @param defaultValue 初期値
   */
  public show(title: string, optionValues: string[], defaultValue?: string): void {
    this.title = title
    this.optionValues = optionValues
    this.inputValue = defaultValue || ''

    this.modalWindow.show()
  }

  /**
   * 入力値の確定(送信)処理
   */
  private submit(): void {
    // 親コンポーネントにイベントを通知し、入力値を受け渡す
    this.$emit('submit', this.singleChoices.selectedValue)

    this.hide()
  }

  /**
   * モーダル消去時のイベントを通知
   *   使用時に@closed='function'と設定すればモーダル消去時に処理の実行が可能
   */
  private closed(): void {
    this.$emit('closed')
  }
}
